
import Vue from 'vue'
import Contact from './contact'
export default Vue.extend({
    props: {
        contact: Object as () => Contact
    }
})
